export default {
  // Sidebar
  workspaces: 'Воркспейс',
  expandChatSidebar: 'Развернуть боковую панель чатов',
  collapseChatSidebar: 'Свернуть боковую панель чатов',
  selectWorkspace: 'Выбрать воркспейс',
  openWorkspaceSettings: 'Открыть настройки воркспейса',
  createWorkspace: 'Создать Воркспейс',
  agents: 'Агенты',
  automations: 'Автоматизации',
  settings: 'Настройки',
  chats: 'Чаты',
  newChat: 'Новый чат',
  startNewChat: 'Начать новый чат',
  noAccessToWorkspace: 'У вас нет доступа к этому воркспейсу.',
  noChatsYet: 'Чатов пока нет.',
  automationChatTooltip: 'Автоматизация: {{title}}',
  draftLabel: 'draft',
  generatingChatTitle: 'Генерация названия чата',
  generatingReply: 'Генерация ответа',
  approvalWaiting: 'Ожидает вашего решения',
  approvalModeLabel: 'Режим подтверждения действий',
  approvalModeMenuTitle: 'Как подтверждать действия?',
  approvalModeAsk: 'Запрашивать разрешения',
  approvalModeAskDescription:
    'Подтверждение будет запрошено, если действие нельзя однозначно авторизовать из вашего сообщения.',
  approvalModeApproveForMe: 'Подтверждать за меня',
  approvalModeApproveForMeDescription:
    'Все действия с изменением данных в этом чате будут подтверждаться автоматически.',
  approvalModeUpdateFailed: 'Не удалось изменить режим подтверждения',
  approvalAutomaticallyApproved: 'Подтверждено автоматически',
  openChatActions: 'Открыть действия чата',
  chatActionsFor: 'Действия для чата «{{title}}»',
  renameChat: 'Редактировать',
  renameChatTitle: 'Редактировать название чата',
  renameChatPlaceholder: 'Введите название чата',
  renameChatSave: 'Сохранить',
  renameChatCancel: 'Отмена',
  renameChatEmpty: 'Введите название чата.',
  renameChatTooLong: 'Название чата должно быть не длиннее {{count}} символов.',
  renameChatFailed: 'Не удалось переименовать чат',
  renameChatForbidden: 'У вас нет прав для редактирования названия этого чата.',
  deleteChatTitle: 'Удалить чат «{{title}}»',
  deleteChatConfirm:
    'Вы уверены, что хотите удалить этот чат? Это действие необратимо.',
  deleteChat: 'Удалить чат',
  messagesUsedLabel: 'Использовано сообщений',
  messagesQuotaResetNote: 'Лимит обновится в начале следующего месяца.',
  workspaceLimitReached: 'Достигнут лимит воркспейсов',
  workspaceCreationUnavailable: 'Создание воркспейса недоступно',
  workspaceCreationUnavailableDescription:
    'Ваш текущий план или уровень доступа не позволяет создать ещё один воркспейс.',

  // Chat shell
  workspaceUnavailable: 'Воркспейс недоступен',
  chatUnavailable: 'Чат недоступен',
  startFirstChat: 'Начните первый чат',
  startFirstChatDescription:
    'Напишите свой первый вопрос, чтобы создать приватный чат в этом воркспейсе.',
  selectAChat: 'Выберите чат',
  selectAChatDescription:
    'Откройте чат из боковой панели или отправьте новое сообщение.',
  writeMessage: 'Спросить Laplace',
  messageQuotaWarningTitle: 'Почти исчерпан месячный лимит сообщений',
  messageQuotaWarningDescription:
    'На Free-плане для этого воркспейса в этом месяце осталось сообщений: {{count}}.',
  messageQuotaBlockedTitle: 'Месячный лимит сообщений исчерпан',
  messageQuotaBlockedDescription:
    'Вы использовали все сообщения Free-плана для этого воркспейса в текущем месяце. Перейдите на платный план для безлимитных сообщений.',
  messageQuotaBlockedPlaceholder: 'Месячный лимит сообщений исчерпан',
  messageQuotaUpgradeCta: 'Обновить план',
  trialExpiredPlaceholder:
    'Пробный период истёк. Обновите план, чтобы продолжить.',
  send: 'Отправить',
  replyGenerationFailed: 'Laplace не вернул ответ',
  resendMessage: 'Отправить повторно',
  copyMessage: 'Копировать',
  copiedMessage: 'Скопировано',
  messageCopied: 'Скопировано в буфер обмена',
  messageCopyFailed: 'Не удалось скопировать сообщение',
  sourceFreshnessTitle: 'Актуальность источников',
  sourceFreshnessFresh: 'Актуально',
  sourceFreshnessPossiblyStale: 'Возможно устарело',
  sourceFreshnessStale: 'Устарело',
  sourceFreshnessUnknown: 'Неизвестно',
  showCode: 'Показать код',
  showDiff: 'Показать дифф',
  showFiletree: 'Показать структуру',
  artifactModalClose: 'Закрыть',
  loadingFileContent: 'Загрузка файла…',
  fileContentError: 'Не удалось загрузить содержимое файла.',
  selectFileToShowCode: 'Выберите файл, чтобы показать код.',
  scrollToBottom: 'Прокрутить вниз',
  privateWorkspaceChat: 'Приватный чат воркспейса',
  generationStatusPreparing: 'Подготавливаю запрос…',
  generationStatusThinking: 'Думаю…',
  generationStatusWriting: 'Пишу ответ…',
  generationStatusToolJira: 'Проверяю Jira…',
  generationStatusToolConfluence: 'Ищу в Confluence…',
  generationStatusToolGithub: 'Проверяю GitHub…',
  generationStatusToolMemory: 'Вспоминаю контекст…',
  generationStatusToolDocs: 'Ищу в документах…',
  generationStatusToolGmail: 'Отправляю письмо…',
  generationStatusToolYandexMail: 'Проверяю Яндекс Почту…',
  generationStatusToolCalendar: 'Проверяю календарь…',
  generationStatusToolGeneric: 'Работаю над запросом…',
  thinkingTraceTitle: 'Размышления',
  thinkingTraceExpand: 'Показать размышления',
  thinkingTraceCollapse: 'Скрыть размышления',

  // Empty state
  noWorkspacesYet: 'Воркспейсов пока нет',
  noWorkspacesDescription:
    'Вы в {{organizationName}}. Создайте воркспейс, чтобы начать.',
  noWorkspaceAccess: 'Нет доступа к воркспейсу',
  noWorkspaceAccessDescription:
    'Вы в {{organizationName}}, но вас ещё не добавили ни в один воркспейс. Попросите владельца организации добавить вас.',
  trialExpiredNoWorkspaceTitle: 'Пробный период истёк',
  trialExpiredNoWorkspaceDescription:
    'Срок пробного периода в {{organizationName}} закончился, а воркспейс так и не был создан. Продлите подписку, чтобы создать воркспейс.',

  // Create stepper
  createWorkspaceTitle: 'Создать воркспейс',
  createWorkspaceSubtitle: 'Следуйте шагам для настройки воркспейса.',
  stepNumber: 'Шаг {{number}}',
  stepDetails: 'Детали воркспейса',
  stepPlugins: 'Плагины',
  stepDocuments: 'Документы',
  stepUsers: 'Добавить пользователей',
  stepReview: 'Проверка',
  selectOrganization: 'Выберите организацию',
  selectOrganizationDescription:
    'Выберите организацию в боковой панели для создания воркспейса.',
  noWorkspaceAccessStepper: 'Нет доступа к воркспейсу',
  noWorkspaceAccessStepperDescription:
    'Попросите владельца или администратора организации создать воркспейс для вас.',
  workspaceName: 'Название воркспейса',
  enterWorkspaceName: 'Введите название воркспейса',
  workspaceDescription: 'Описание',
  workspaceDescriptionPlaceholder: 'Необязательное описание этого воркспейса',
  configureIntegrations: 'Настройте интеграции для этого воркспейса.',
  jira: 'Jira',
  confluence: 'Confluence',
  gmail: 'Gmail',
  enableJiraIntegration: 'Включить интеграцию Jira для этого воркспейса.',
  enableConfluenceIntegration:
    'Включить интеграцию Confluence для этого воркспейса.',
  enableGmailIntegration: 'Включить общий Gmail для этого воркспейса.',
  github: 'GitHub',
  enableGitHubIntegration: 'Включить интеграцию GitHub для этого воркспейса.',
  jiraBaseUrl: 'Jira Cloud URL',
  jiraBaseUrlPlaceholder: 'https://your-company.atlassian.net',
  jiraProject: 'Jira Project',
  jiraProjectPlaceholder: 'Выберите проект Jira',
  jiraProjectNone: 'Не выбирать проект',
  defaultProjectLabel: 'Проект по умолчанию',
  defaultRepoLabel: 'Репозиторий по умолчанию',
  defaultResourceNotSet: 'Не задан',
  defaultResourceSet: 'установить',
  githubDefaultRepo: 'Репозиторий по умолчанию',
  githubDefaultRepoPlaceholder: 'Выберите репозиторий',
  githubDefaultRepoNone: 'Не выбирать репозиторий',
  loadingJiraProjects: 'Загрузка проектов Jira...',
  unableToLoadJiraProjects: 'Не удалось загрузить проекты Jira.',
  noJiraProjectsAvailable: 'Доступные проекты Jira не найдены.',
  confluenceBaseUrl: 'Confluence Cloud URL',
  confluenceBaseUrlPlaceholder: 'https://your-company.atlassian.net',
  githubScope: 'Доступ к репозиториям',
  githubScopeAllRepositories: 'Все репозитории @{{account}}',
  githubScopeSelectedRepositories: 'Выбранные репозитории @{{account}}',
  githubScopeConfiguredOnGitHub: '(настраивается на GitHub).',
  githubConfigureOnGitHub: 'Настроить на GitHub',
  githubSelectedRepositories: 'Выбранные репозитории',
  loadingGitHubRepositories: 'Загрузка репозиториев...',
  unableToLoadGitHubRepositories: 'Не удалось загрузить репозитории.',
  noGitHubRepositoriesAvailable: 'Установке не выданы репозитории.',
  githubSettingsAuthNote:
    'Установите GitHub App от Laplace: аккаунт или организацию и репозитории вы выберете на GitHub.',
  jiraAuthNote:
    'Аутентификация Jira выполняется после создания воркспейса из настроек воркспейса с помощью кнопки «Аутентификация с Jira». Проект Jira можно выбрать после подключения.',
  addUsersDescription:
    'Добавьте пользователей, которые должны иметь доступ к этому воркспейсу.',
  searchUsers: 'Поиск пользователей по имени или email',
  noUsersMatch: 'Нет пользователей, соответствующих запросу.',
  reviewDescription: 'Проверьте детали воркспейса перед созданием.',
  workspace: 'Воркспейс',
  plugins: 'Плагины',
  jiraEnabled: 'Включена',
  jiraDisabled: 'Выключена',
  oauthNote: 'OAuth-аутентификация будет завершена после создания воркспейса.',
  selectedUsers: 'Выбранные пользователи ({{count}})',
  selectedUsersTitle: 'Пользователи',
  selectedUsersCount: 'Выбрано: {{number}}',
  documentsAddedCount: 'Добавлено: {{number}}',
  selectedUsersDescription:
    'Пользователи, которые будут добавлены в воркспейс.',
  noUsersSelected: 'Пользователи не выбраны.',
  noPluginsConnected: 'Ни один плагин не подключён.',

  // Workspace settings
  workspaceNotFound: 'Воркспейс не найден',
  accessDenied: 'Доступ запрещён',
  accessDeniedDescription: 'У вас нет доступа к этому воркспейсу.',
  settingsTitle: 'Настройки — {{name}}',
  settingsDescription: 'Управление конфигурацией воркспейса и участниками.',
  deleteWorkspace: 'Удалить воркспейс',
  leaveWorkspace: 'Покинуть воркспейс',
  general: 'Общее',
  members: 'Участники',
  enableJiraPlugin: 'Включить плагин Jira',
  jiraAuthDescription:
    'Администратор воркспейса авторизуется один раз через Atlassian OAuth. Все участники воркспейса используют общее подключение Jira.',
  jiraSecurityNote:
    'Создайте пользователя Jira с именем «Laplace» и предоставьте ему только необходимые права: «Browse projects» и «Add comments». Затем начните аутентификацию и войдите в Jira этим пользователем.',
  jiraAuthentication: 'Аутентификация Jira',
  confluenceAuthentication: 'Аутентификация Confluence',
  jiraStatus: 'Статус: {{status}}',
  confluenceStatus: 'Статус: {{status}}',
  gmailStatus: 'Статус: {{status}}',
  loadingJiraStatus: 'Загрузка статуса подключения Jira...',
  jiraStatusError: 'Не удалось загрузить статус подключения Jira.',
  connectedSite: 'Подключённый сайт',
  notConnected: 'Не подключено',
  connectedAccount: 'Подключённый аккаунт',
  connectedAccounts: 'Подключённые аккаунты',
  integrationPermissions: 'Что разрешено интеграции',
  atlassianScopesDisclaimer:
    'Эти разрешения задают типы операций, доступных приложению. Фактический доступ к данным всё равно ограничен правами подключённого Atlassian-аккаунта.',
  gmailScopesDisclaimer:
    'Эти разрешения выданы Google OAuth для подключённого общего ящика.',
  yandexMailScopesDisclaimer:
    'Эти разрешения выданы Yandex OAuth для подключённого общего ящика.',
  githubPermissionsDisclaimer:
    'GitHub App ограничивает доступ выбранным аккаунтом и репозиториями. Точные права приложения настраиваются в GitHub.',
  noReportedScopes: 'Разрешения не получены.',
  scopeGroupRead: 'Чтение',
  scopeGroupWrite: 'Запись',
  scopeGroupManage: 'Управление',
  scopeGroupProfile: 'Профиль',
  scopeGroupMail: 'Почта',
  scopeGroupOther: 'Другое',
  reconnectJira: 'Переподключить Jira',
  reconnectConfluence: 'Переподключить Confluence',
  authenticateWithJira: 'Аутентификация с Jira',
  authenticateWithConfluence: 'Аутентификация с Confluence',
  authenticateWithGmail: 'Подключить Gmail',
  reconnectGmail: 'Переподключить Gmail',
  connectAnotherGmailAccount: 'Подключить ещё аккаунт Gmail',
  gmailDraftPermissionRequired:
    'Переподключите Gmail, чтобы разрешить создание черновиков. До этого отправка писем продолжит работать.',
  disconnect: 'Отключить',
  enabledPlugins: 'Включённые плагины',
  noPluginsEnabled: 'Плагины не включены.',
  memberCount_one: '{{count}} участник',
  memberCount_few: '{{count}} участника',
  memberCount_many: '{{count}} участников',
  noMembersListed: 'Нет участников.',
  owner: 'владелец',
  admin: 'админ',
  member: 'участник',
  deleteWorkspaceConfirmTitle: 'Удалить воркспейс',
  deleteWorkspaceConfirmDescription:
    'Вы уверены, что хотите удалить этот воркспейс? Это действие необратимо. Все данные воркспейса будут удалены.',
  deleteWorkspaceConfirm:
    'Вы уверены, что хотите удалить этот воркспейс? Это действие необратимо. Все данные воркспейса будут удалены.',
  leaveWorkspaceConfirmTitle: 'Покинуть воркспейс',
  leaveWorkspaceConfirmDescription:
    'Вы уверены, что хотите покинуть этот воркспейс? Ваши данные в этом воркспейсе будут удалены.',
  leaveWorkspaceConfirm:
    'Вы уверены, что хотите покинуть этот воркспейс? Ваши данные в этом воркспейсе будут удалены.',
  generalTab: 'Общее',
  membersTab: 'Участники',
  docsTab: 'Документы',
  rulesTab: 'Правила',
  rulesTitle: 'Правила воркспейса',
  rulesDescription:
    'Правила, которые агенты учитывают во всех чатах воркспейса.',
  rulesAdd: 'Добавить правило',
  rulesCreateLabel: 'Текст нового правила',
  rulesCreated: 'Правило воркспейса добавлено.',
  rulesLoading: 'Загрузка правил…',
  rulesLoadFailed: 'Не удалось загрузить правила воркспейса.',
  rulesRetry: 'Повторить',
  rulesEmptyTitle: 'Правил пока нет',
  rulesEmptyDescription:
    'Добавьте правило здесь или опишите устойчивый процесс команды в чате.',
  rulesUpdatedAt: 'Обновлено {{date}}',
  rulesEdit: 'Изменить правило',
  rulesEditLabel: 'Текст правила',
  rulesDelete: 'Удалить правило',
  rulesCancel: 'Отмена',
  rulesSave: 'Сохранить',
  rulesUpdated: 'Правило воркспейса обновлено.',
  rulesDeleted: 'Правило воркспейса удалено.',
  rulesMutationFailed: 'Не удалось изменить правило воркспейса.',
  rulesDeleteConfirmTitle: 'Удалить правило?',
  rulesDeleteConfirmDescription:
    'Правило перестанет применяться в будущих диалогах. Это действие необратимо.',
  rulesVersionConflictTitle: 'Правило уже изменилось',
  rulesVersionConflictDescription:
    'Другой участник сохранил новую версию. Список обновлён.',
  rulesDuplicateTitle: 'Дублирующееся правило',
  rulesDuplicateDescription:
    'В воркспейсе уже есть правило с таким же смыслом.',
  rulesConflictTitle: 'Конфликт правил',
  rulesConflictDescription:
    'Эта формулировка противоречит другому правилу воркспейса. Сначала проверьте текущие правила.',
  ownerRole: 'владелец',
  memberRole: 'участник',
  pleaseTryAgain: 'Пожалуйста, попробуйте ещё раз.',
  connectorOfflineTitle: 'Интеграция недоступна',
  connectorOfflineDescription:
    'Коннектор оффлайн. Повторите запрос после восстановления связи.',
  connectorBackOnlineTitle: 'Коннектор снова в сети',
  connectorBackOnlineDescription:
    'Можно продолжить работу. Повторно отправляем ваш последний запрос…',
  jiraSettingsAuthNote:
    'Администратор воркспейса авторизуется один раз через Atlassian OAuth. После подключения можно выбрать Jira Project из доступных проектов.',
  confluenceSettingsAuthNote:
    'Администратор воркспейса авторизуется один раз через Atlassian OAuth. Все участники воркспейса используют общее подключение Confluence.',
  jiraSetupInstructions:
    'Создайте пользователя Jira с именем «Laplace» и предоставьте ему только необходимые права: «Browse projects» и «Add comments». Затем начните аутентификацию и войдите в Jira этим пользователем.',
  confluenceSetupInstructions:
    'Подключите Atlassian-аккаунт с доступом к нужным пространствам Confluence. Все участники воркспейса смогут задавать вопросы по доступным страницам.',
  jiraStatusNotConnected: 'Не подключено',
  confluenceStatusNotConnected: 'Не подключено',
  githubStatusNotConnected: 'Не подключено',
  jiraStatusDisabled: 'Выключена',
  confluenceStatusDisabled: 'Выключена',
  githubStatusDisabled: 'Выключена',
  jiraStatusConnected: 'Подключена',
  jiraStatusReconnectRequired: 'Нужно переподключить',
  confluenceStatusConnected: 'Подключена',
  confluenceStatusReconnectRequired: 'Нужно переподключить',
  gmailStatusNotConnected: 'Не подключён',
  gmailStatusDisabled: 'Выключен',
  gmailStatusConnected: 'Подключён',
  gmailStatusReconnectRequired: 'Нужно переподключить',
  gmailSetupInstructions:
    'Подключите общий почтовый ящик для этого воркспейса. Участники смогут создавать черновики и отправлять письма по явному запросу.',
  githubStatusConnected: 'Подключена',
  githubStatusReconnectRequired: 'Нужно переподключить',
  githubStatusScopeInvalid: 'Подключена — нужно обновить скоуп',
  loadingJiraConnection: 'Загрузка статуса подключения Jira...',
  loadingConfluenceConnection: 'Загрузка статуса подключения Confluence...',
  loadingGitHubConnection: 'Загрузка статуса подключения GitHub...',
  unableToLoadJiraConnection: 'Не удалось загрузить статус подключения Jira.',
  unableToLoadConfluenceConnection:
    'Не удалось загрузить статус подключения Confluence.',
  unableToLoadGitHubConnection:
    'Не удалось загрузить статус подключения GitHub.',
  githubSetupInstructions:
    'Установите GitHub App, выберите аккаунт или организацию и репозитории на GitHub — затем вы вернётесь сюда.',
  githubAuthentication: 'Установка GitHub App',
  githubStatus: 'Статус: {{status}}',
  githubInstallApp: 'Установить GitHub App',
  githubInstallAnotherApp: 'Установить другое подключение GitHub App',
  githubReinstallApp: 'Перенастроить GitHub App',
  githubLinkPickerTitle: 'Выберите установку GitHub',
  githubLinkPickerHint:
    'Выберите аккаунт или организацию, где GitHub App уже установлен. Без экрана Configure на GitHub.',
  githubLinkPickerExpired:
    'Сессия привязки истекла. Закройте и снова нажмите «Установить GitHub App».',
  githubLinkPickerDismiss: 'Закрыть',

  // Plugins tab
  pluginsTab: 'Плагины',
  jiraPluginDescription:
    'Создавайте, обновляйте и отслеживайте задачи проекта.',
  confluencePluginDescription: 'Ищите ответы на вопросы по вашим страницам.',
  gmailPluginDescription: 'Отправляйте письма из общего ящика Gmail.',
  githubPluginDescription:
    'Ищите ответы на вопросы по issues, pull requests и репозиториям.',
  addPlugin: 'Добавить плагин',
  addPluginTitle: 'Добавить плагин',
  addPluginDescription:
    'Выберите интеграцию для подключения к этому воркспейс.',
  allPluginsAdded: 'Все доступные плагины уже добавлены.',
  pluginSettings: 'Настройки',
  pluginStatusConnected: 'Подключено',
  pluginStatusNotConnected: 'Не подключено',
  pluginStatusDisabled: 'Выключено',
  pluginStatusReconnectRequired: 'Нужно переподключить',
  pluginsConnectedCount: 'Подключено: {{number}}',
  pluginsReadOnlyHint: 'Плагины, включённые для этого воркспейс.',

  // Members tab
  searchByNameOrEmail: 'Поиск по имени или email...',
  selectAll: 'Выбрать все',
  clearSelection: 'Снять выбор',
  showOnlySelected: 'Показать только выбранных',
  ownerBadge: 'Владелец',
  userRole: 'Пользователь',
  adminRole: 'Админ',
  noMembersFound: 'Участники не найдены.',
  removeMembersConfirmTitle: 'Удалить участников',
  removeMembersConfirm: 'Вы уверены? Данные {{names}} будут удалены.',

  // Docs tab
  docsUploadTitle: 'Перетащите документ сюда',
  docsUploadDescription: 'PDF, DOCX, PPTX, XLSX, MD или TXT до 10 MB.',
  docsChooseFile: 'Выбрать файл',
  docsUploading: 'Загрузка...',
  docsUploadSuccessTitle: 'Загружено: {{count}}',
  docsUploadSuccessDescription: 'Обработка началась.',
  docsUploadSkippedTitle: 'Некоторые файлы пропущены',
  docsUploadSkippedDescription:
    '{{count}} файл(ов) не подходят по формату или лимиту 10 MB.',
  docsUploadFailedTitle: 'Не удалось загрузить: {{count}}',
  docsDuplicateTitle: 'Уже загружено',
  docsDuplicateDescription:
    'Документ с таким же содержимым уже есть в этом рабочем пространстве.',
  docsName: 'Название',
  docsType: 'Тип',
  docsUploadedAt: 'Загружен',
  docsUploadedBy: 'Кто загрузил',
  docsDeletedUser: 'Удалённый пользователь',
  docsSize: 'Размер',
  docsStatus: 'Статус',
  docsActions: 'Действия',
  docsOpen: 'Скачать документ',
  docsOpenFailed: 'Не удалось скачать документ',
  docsRetryIndexing: 'Повторить',
  docsProcessingRestarted: 'Обработка перезапущена',
  docsProcessingRestartedDescription: 'Файл скоро будет доступен.',
  docsRetryFailed: 'Не удалось перезапустить обработку',
  docsReindex: 'Улучшить через Docling',
  docsReindexAvailableTooltip:
    'Повторно обработать документ через Docling для улучшения структуры, таблиц и форматирования.',
  docsReindexDisabledTooltip:
    'Docling отключён, поэтому улучшенная обработка недоступна.',
  docsReindexingTooltip: 'Выполняется улучшенная обработка.',
  docsReindexStarted: 'Улучшенная обработка запущена',
  docsReindexStartedDescription:
    'Текущая версия остаётся доступной для поиска во время обработки.',
  docsReindexFailed: 'Не удалось запустить улучшенную обработку',
  docsReindexAlreadyInProgress: 'Улучшенная обработка уже выполняется.',
  docsFailureNoTextContent:
    'В документе не найден текст, который можно добавить в поиск.',
  docsFailureIndexingFailed:
    'Не удалось обработать документ. Повторите попытку.',
  docsFailureDoclingRequiredDisabled:
    'Для обработки PPTX и XLSX необходим Docling, но он отключён.',
  docsFailureDoclingRequiredUnavailable:
    'Для обработки PPTX и XLSX необходим Docling, но сейчас он недоступен. Повторите попытку позже.',
  docsFailureDoclingRequiredConversionFailed:
    'Docling не смог обработать этот PPTX или XLSX. Проверьте файл и повторите попытку.',
  docsFailureDoclingUpgradeUnavailable:
    'Docling сейчас недоступен. Текущая версия документа осталась доступна для поиска.',
  docsFailureDoclingUpgradeFailed:
    'Docling не смог улучшить обработку документа. Текущая версия осталась доступна для поиска.',
  docsFailureMalformed:
    'Файл повреждён: нарушена внутренняя структура документа. Улучшенная обработка невозможна, текущая версия осталась доступна для поиска. Пересохраните файл в Word и загрузите заново.',
  docsLoading: 'Загрузка документов...',
  docsEmpty: 'Документы пока не загружены.',
  docsDelete: 'Удалить документ',
  docsDeleteConfirm: 'Удалить «{{name}}»?',
  docsDeleted: 'Файл удалён',
  docsDeleteFailed: 'Не удалось удалить файл',
  docsInvalidFormat: 'Неподдерживаемый формат документа',
  docsTooLarge: 'Документ слишком большой',
  docsStatus_pending: 'Обработка',
  docsStatus_reindexing: 'Улучшение',
  docsStatus_indexed: 'Готово',
  docsStatus_failed: 'Ошибка',

  // Notifications
  jiraConnected: 'Jira подключена',
  confluenceConnected: 'Confluence подключён',
  gmailConnected: 'Gmail подключён',
  githubConnected: 'GitHub подключён',
  githubOAuthCompleting: 'Завершение авторизации GitHub',
  githubOAuthReturning: 'Возвращаем вас в рабочую область…',
  jiraDisconnected: 'Jira отключена',
  confluenceDisconnected: 'Confluence отключён',
  gmailDisconnected: 'Gmail отключён',
  gmailAccountDisconnected: 'Аккаунт Gmail {{email}} отключён',
  githubDisconnected: 'GitHub отключён',
  jiraConnectionFailed: 'Не удалось подключить Jira',
  confluenceConnectionFailed: 'Не удалось подключить Confluence',
  gmailConnectionFailed: 'Не удалось подключить Gmail',
  githubConnectionFailed: 'Не удалось подключить GitHub',
  gmailConnectionFailedDescription:
    'Не удалось подключить Gmail. Проверьте настройки интеграции и попробуйте снова.',
  gmailDisconnectFailedDescription:
    'Не удалось отключить Gmail. Попробуйте снова.',
  unableToDisconnectJira: 'Не удалось отключить Jira',
  unableToDisconnectConfluence: 'Не удалось отключить Confluence',
  unableToDisconnectGitHub: 'Не удалось отключить GitHub',
  oauthPopupLoadingTitle: 'Загрузка…',
  oauthPopupLoadingMessage: 'Загрузка авторизации…',
  popupBlocked: 'Всплывающее окно заблокировано',
  popupBlockedDescription:
    'Разрешите всплывающие окна для Laplace, чтобы продолжить аутентификацию Jira.',
  popupBlockedConfluenceDescription:
    'Разрешите всплывающие окна для Laplace, чтобы продолжить аутентификацию Confluence.',
  popupBlockedGmailDescription:
    'Разрешите всплывающие окна для Laplace, чтобы продолжить аутентификацию Gmail.',
  yandexMail: 'Яндекс Почта',
  enableYandexMailIntegration:
    'Включить общую Яндекс Почту для этого воркспейса.',
  yandexMailPluginDescription:
    'Ищите, читайте, создавайте черновики и отправляйте письма из общего ящика Яндекс Почты.',
  yandexMailStatus: 'Статус: {{status}}',
  yandexMailStatusNotConnected: 'Не подключена',
  yandexMailStatusDisabled: 'Выключена',
  yandexMailStatusConnected: 'Подключена',
  yandexMailStatusReconnectRequired: 'Нужно переподключить',
  yandexMailSetupInstructions:
    'Подключите общую Яндекс Почту для этого воркспейса. Все участники воркспейса смогут работать с ней через агента.',
  authenticateWithYandexMail: 'Подключить Яндекс Почту',
  reconnectYandexMail: 'Переподключить Яндекс Почту',
  connectAnotherYandexMailAccount: 'Подключить ещё аккаунт Яндекс Почты',
  yandexMailConnected: 'Яндекс Почта подключена',
  yandexMailDisconnected: 'Яндекс Почта отключена',
  yandexMailAccountDisconnected: 'Аккаунт Яндекс Почты {{email}} отключён',
  yandexMailConnectionFailedDescription:
    'Не удалось подключить Яндекс Почту. Проверьте OAuth, IMAP и SMTP и попробуйте снова.',
  yandexMailDisconnectFailedDescription:
    'Не удалось отключить Яндекс Почту. Попробуйте снова.',
  popupBlockedYandexMailDescription:
    'Разрешите всплывающие окна для Laplace, чтобы продолжить подключение Яндекс Почты.',
  calendar: 'Календарь',
  calendarPluginDescription:
    'Подключите один общий основной календарь Google, Яндекс или Outlook.',
  googleCalendar: 'Google Календарь',
  googleCalendarPluginDescription:
    'Подключите основной Google Календарь администратора.',
  yandexCalendar: 'Яндекс Календарь',
  yandexCalendarPluginDescription:
    'Подключите основной Яндекс Календарь администратора.',
  outlookCalendar: 'Outlook Календарь',
  outlookCalendarPluginDescription:
    'Подключите основной Outlook Календарь администратора.',
  calendarWorkspaceSharingWarning:
    'Подключённый основной календарь станет доступен всем участникам этого воркспейса через Laplace.',
  calendarProvider: 'Провайдер',
  calendarSyncState: 'Состояние синхронизации',
  calendarLastSuccessfulSync: 'Последняя успешная синхронизация',
  calendarReconnectRequired:
    'Нужно переподключить календарь или успешно завершить синхронизацию.',
  calendarConnectProvider: 'Подключить {{provider}}',
  calendarReconnectProvider: 'Переподключить {{provider}}',
  calendarReplaceTitle: 'Заменить общий календарь?',
  calendarReplaceDescription:
    '{{current}} будет заменён на {{next}} только после успешного OAuth нового подключения. До этого старый календарь останется активным.',
  calendarConfirmReplace: 'Подтвердить замену',
  calendarConnected: 'Календарь подключён',
  calendarDisconnected: 'Календарь отключён',
  calendarConnectionFailed:
    'Не удалось подключить календарь. Попробуйте снова.',
  calendarDisconnectFailed: 'Не удалось отключить календарь. Попробуйте снова.',
  calendarPopupBlockedDescription:
    'Разрешите всплывающие окна для Laplace, чтобы продолжить подключение календаря.',
  telegram: 'Telegram',
  telegramPluginDescription:
    'Отвечает в привязанных групповых чатах по данным сервисов пространства (только чтение).',
  telegramGenerateCode: 'Сгенерировать код подключения',
  telegramCodeInstruction:
    'В нужной группе (с добавленным ботом) отправьте от имени администратора: /link {{code}}',
  telegramCodeExpiresAt: 'Код действует до {{time}}',
  telegramLinkedChats: 'Подключённые чаты',
  telegramNoLinkedChats: 'Пока нет подключённых чатов.',
  telegramTasksEnabled: 'Создание и обновление задач из чата',
  telegramTasksHint:
    'Участники смогут попросить бота завести задачу или дописать комментарий и статус в существующую. Ничего не уходит в Jira, пока автор просьбы не подтвердит это кнопкой.',
  telegramTasksUpdateFailed: 'Не удалось изменить настройку. Попробуйте снова.',
  telegramUnlink: 'Отвязать',
  telegramGenerateFailed: 'Не удалось сгенерировать код. Попробуйте снова.',
  telegramUnlinkFailed: 'Не удалось отвязать чат. Попробуйте снова.',
  cancel: 'Отмена',
}
